import React, { useEffect } from 'react'
import imgimagem1 from '../../assets/news-events/imagem1.png'
import CenterStage from '../../Components/CenterStage/CenterStage'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import imgimagem2 from '../../assets/news-events/imagem2.png'
import imgimagem3 from '../../assets/news-events/imagem3.png'
import imgimagem4 from '../../assets/news-events/imagem4.png'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import imgPtNonconductivestage from '../../assets/news-events/PtNonconductivestage.png'
import imgEngNonconductivestage from '../../assets/news-events/EngNonconductivestage.png'

const Nonconductivenews = () => {
    const { t, i18n } = useTranslation();
    const isPortuguese = i18n.language === 'pt' || i18n.language?.startsWith('pt');
    const centerStageImage = isPortuguese ? imgPtNonconductivestage : imgEngNonconductivestage;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="nonconductive-news-page">
            <CenterStage
                imageSrc={imgimagem1}
                title={"Non-conductive hydraulic hose: A matter of safety"}
                paragraph={[
                    "In industrial environments with electrical hazards, one technical detail can be the difference between safe operation and serious accidents: the choice of hydraulic hose. Do you know when to use a non-conductive hydraulic hose? Understand how this solution increases safety, complies with international standards, and protects your team, especially in high-pressure and high-voltage operations."
                ]}
            />

            <ImageDescription
                subtitle="March 11, 2026"
                paragraph="Text: Gabriela Nascimento"
                alignment="left"
            />
            {/* <br /><br /> */}
            <br /><br />

            {/* <ImageDescription imageSrc={imgimagem1} /> */}

            <ImageDescription
                title={"The invisible risk in hydraulic systems"}
                paragraph="In sectors such as construction, mining, oil, energy, and electrical maintenance, it is common to operate near energized equipment. The problem? Not all hydraulic hoses provide the necessary electrical insulation."
                alignment="left"
            />

            <ImageDescription
                paragraph={"When applied incorrectly, an inadequate hose can:"}
                bulletPoints={["Increase the risk of electric shock", "Compromise staff safety", "Lead to non-compliance with technical standards", "Interrupt critical operations"]}
                bulletType="bullets"
                alignment="left"
            />

            <br /><br />
            <br /><br />

            <ImageDescription imageSrc={imgimagem2} />


            <ImageDescription
                title={"What is a non-conductive hydraulic hose?"}
                paragraph="Non-conductive hydraulic hoses are designed for transferring fluids in environments where there is a risk of contact with electrical current."
                alignment="left"
            />

            <ImageDescription
                paragraph={"Unlike conductive hoses (which dissipate static charges), they:"}
                bulletPoints={["Does not conduct electricity", "Provides additional electrical insulation", "Suitable for water, air, and non-hazardous fluids", "Maintains high performance under pressure"]}
                bulletType="bullets"
                alignment="left"
            />

            <ImageDescription
                title={"Where is non-conductive hose indispensable?"}
                subtitle={"Industrial hydraulic systems"}
                paragraph="High-pressure operations near electrical panels or energized networks require extra insulation."
                alignment="left"
            />

            <ImageDescription
                subtitle={"High-voltage equipment"}
                paragraph="Offshore platforms, substations, and transmission line maintenance require protection against electric shock."
                alignment="left"
            />

            <ImageDescription
                subtitle={"Heavy machinery"}
                paragraph="Cranes, excavators, and agricultural equipment operate under high pressure and often in electrically sensitive environments."
                alignment="left"
            />

            <br /><br />
            <br /><br />

            <ImageDescription imageSrc={imgimagem3} />

            <ImageDescription
                title={"Our non-conductive solution: NY 800 NC"}
                paragraph="Designed for environments with a risk of electrical contact, it combines safety, mechanical resistance, and regulatory compliance, reducing operational risks and increasing system reliability."
                alignment="left"
                bulletType="bullets"
                bulletPoints={["With an inner layer of polyester elastomer, aramid braid reinforcement, and an outer layer of polyurethane (PUR), it ensures high resistance to ozone and abrasion", "Its electrical conductivity remains at < 50 μA (according to ISO 3949)", "With 7 variations, it also has an operating pressure of 140 to 350 bar", "It is compatible with working temperatures ranging from -40 °C to +93 °C, or water/oil emulsions (up to +60 °C) and water (0 °C to +60 °C)", "Excellent flexural strength, low volumetric expansion, and high durability in harsh environments."]}
            />

            <ImageDescription
                paragraph={"The NY 800 NC from HANSA-FLEX is the ideal choice for those who need to combine electrical safety, technical compliance, and hydraulic performance in a single component."}
                alignment="left"
            />

            <ImageDescription title="How to choose between conductive and non-conductive hoses?" />

            <ImageDescription
                paragraph="This decision must consider five critical factors:"
                bulletType="numbers"
                bulletPoints={[
                    { point: "Type of fluid", paragraph: "Flammable fluids may require static dissipation (conductive). Water or non-hazardous fluids can use non-conductive versions." },
                    { point: "Electrical risk", paragraph: "Is there proximity to energized equipment? If so, electrical insulation is essential." },
                    { point: "Pressure and temperature", paragraph: "The hose must withstand actual operating conditions." },
                    { point: "Chemical compatibility", paragraph: "Avoid material degradation or fluid contamination." },
                    { point: "Regulatory compliance", paragraph: "The ISO 3949 standard guarantees internationally recognized technical parameters." }
                ]}
                alignment="left"
            />

            <ImageDescription
                paragraphs={["If you have any questions, relying on specialized technical support prevents costly mistakes in maintenance, fines, or accidents. That is why our sales team specializes in hydraulic hoses and can visit your company to assess which type of hose is best suited for your needs."]}
                alignment="left"
            />

            <br /><br />
            <br /><br />

            <ImageDescription imageSrc={imgimagem4} />

            <ImageDescription
                title={"Safety is not optional, it is design"}
                paragraph="In complex industrial environments, electrical safety and hydraulic performance go hand in hand. The right non-conductive hydraulic hose protects people, equipment, and results."
                alignment="left"
            />

            <ImageDescription
                paragraph="Want to know if your application requires a certified non-conductive hose?"
                alignment="left"
            />

            <ImageDescription
                paragraph={"Talk to the HANSA-FLEX technical team and request a specialist assessment at your company."}
                alignment="left"
            />

            <Link
                to="/fale-conosco"
                className="ImageText-button nonconductive-contact-btn"
                style={{ display: 'inline-block', marginTop: '0.5rem' }}>
                {t('Talk to us')}
            </Link>

            <br /><br />
            <br /><br />
            
        </div>
    )
}

export default Nonconductivenews